import { CSSProperties, createElement } from "react";
import { systemBlack, systemWhite } from "../../pages/landingPage/constants";

type AnyProps = Record<string, any>;

const searchPanelNavbarContainerStyle: CSSProperties = {
  justifyContent: "left",
  width: "100%",
};

const columnCenteredStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const companyInfoStyle: CSSProperties = {
  cursor: "pointer",
  font: '500 14px/24px "Roboto", sans-serif',
  color: systemBlack,
  padding: 12,
  borderRadius: 4,
  backgroundColor: systemWhite,
};

export const SearchPanelNavbarContainer = ({
  children,
  style,
  ...props
}: AnyProps) =>
  createElement(
    "div",
    {
      style: { ...searchPanelNavbarContainerStyle, ...(style ?? {}) },
      ...props,
    },
    children
  );

export const TopSpan = ({ children, ...props }: AnyProps) =>
  createElement("span", props, children);

export const UserInfo = ({ children, style, ...props }: AnyProps) =>
  createElement(
    "div",
    {
      style: { ...columnCenteredStyle, ...(style ?? {}) },
      ...props,
    },
    children
  );

export const CompanyInfo = ({ children, style, ...props }: AnyProps) =>
  createElement(
    "span",
    {
      style: { ...companyInfoStyle, ...(style ?? {}) },
      ...props,
    },
    children
  );

export const CurrentBalance = ({ children, style, ...props }: AnyProps) =>
  createElement(
    "div",
    {
      style: { ...columnCenteredStyle, ...(style ?? {}) },
      ...props,
    },
    children
  );

export const AmountTotal = ({ children, style, ...props }: AnyProps) =>
  createElement(
    "div",
    {
      style: { ...columnCenteredStyle, ...(style ?? {}) },
      ...props,
    },
    children
  );

export const StyledNavBar = ({ children, ...props }: AnyProps) =>
  createElement("nav", props, children);
